<template>
  <h2
    :class="`size-${size}`"
  >
    <slot />
  </h2>
</template>

<script>
  export default {
    props: {
      size: { type: String, default: 'md' }
    }
  }
</script>

<style scoped lang="scss">
  h2 {
    font-family: 'Poppins';
    color: #070817;

    &.size-md { font-size: 1.75rem }
    &.size-sm { font-size: 1.375rem }
    &.size-xs { font-size: 1.125rem }

    b { font-weight: 600 }
    strong { font-weight: 700 }
  }

  .hl { color: #FF8000; }
</style>